import cn from 'classnames'
import React from 'react'
import {
  PlusCircleIcon,
  InformationCircleIcon,
  CheckCircleIcon
} from '@heroicons/react/outline'

type Props = {
  variant: 'error' | 'info' | 'success' | 'warning'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactElement | string
}

const Notification = ({ variant, size = 'md', children }: Props) => (
  <div
    className={cn('rounded-md flex items-center border border-solid', {
      'bg-red-100 border-red-200': variant === 'error',
      'bg-blue-100 border-blue-200': variant === 'info',
      'bg-green-100 border-green-200': variant === 'success',
      'bg-orange-100 border-orange-200': variant === 'warning',
      'px-1 py-2': size === 'sm',
      'px-2 py-3': size === 'md',
      'px-6 py-6': size === 'lg'
    })}
  >
    <div>
      {variant === 'error' && (
        <PlusCircleIcon
          className={cn('rotate-45 text-red-500 mr-2', {
            'w-6 h-6 mr-2': size === 'sm' || size === 'md',
            'w-8 h-8 mr-4': size === 'lg'
          })}
        />
      )}
      {variant === 'info' && (
        <InformationCircleIcon
          className={cn('text-blue-600 mr-2', {
            'w-6 h-6 mr-2': size === 'sm' || size === 'md',
            'w-8 h-8  mr-4': size === 'lg'
          })}
        />
      )}
      {variant === 'success' && (
        <CheckCircleIcon
          className={cn('text-green-600', {
            'w-6 h-6 mr-2': size === 'sm' || size === 'md',
            'w-8 h-8 mr-4': size === 'lg'
          })}
        />
      )}
    </div>
    <div
      className={cn({
        'text-red-800': variant === 'error',
        'text-blue-800': variant === 'info',
        'text-green-800': variant === 'success',
        'text-orange-800': variant === 'warning',
        'text-xs': size === 'sm',
        'text-sm': size === 'md',
        'text-lg font-medium': size === 'lg'
      })}
    >
      {children}
    </div>
  </div>
)

export default Notification
